var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "237px",
    height: "327px",
    viewBox: "0 0 237 327",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wave_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 237,
    height: 327
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.425324%",
    y1: "-49.5488178%",
    x2: "174.19412%",
    y2: "61.413258%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "66.5470353%",
    y1: "-49.5488178%",
    x2: "183.225369%",
    y2: "61.413258%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "66.8683294%",
    y1: "-49.5488178%",
    x2: "185.812209%",
    y2: "61.413258%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.4653925%",
    y1: "-49.5488178%",
    x2: "190.619351%",
    y2: "61.413258%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.8334827%",
    y1: "-49.5488178%",
    x2: "193.582961%",
    y2: "61.413258%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.1253893%",
    y1: "-49.5488178%",
    x2: "195.933192%",
    y2: "61.413258%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.20558%",
    y1: "-49.5488178%",
    x2: "196.578833%",
    y2: "61.413258%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.4297718%",
    y1: "-49.5488178%",
    x2: "198.383871%",
    y2: "61.413258%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.5374545%",
    y1: "-49.5488178%",
    x2: "199.250859%",
    y2: "61.413258%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.5677051%",
    y1: "-49.5488178%",
    x2: "199.494416%",
    y2: "61.413258%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.7869168%",
    y1: "-49.5488178%",
    x2: "201.259358%",
    y2: "61.413258%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wave_1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lines",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(454.825467, 862.763433) scale(-1, -1) rotate(-145.000000) translate(-454.825467, -862.763433) translate(-306.174533, 263.763433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.392741,986.434909 C515.779336,989.23198 501.418704,915.954311 546.883672,852.175495 C594.736496,785.045788 680.871579,754.278006 690.442144,687.148299 C700.012709,620.018592 657.655782,552.888885 621.055549,552.888885 C570.810084,552.888885 518.171977,530.512316 458.355947,600.439094 C441.67206,619.940274 407.22999,677.411694 391.361994,745.886793 C367.258526,849.909867 380.217071,983.766503 446.392741,986.434909 Z",
    id: "Stroke-1",
    stroke: "url(#linearGradient-3)",
    transform: "translate(535.961429, 767.996865) rotate(-90.000000) translate(-535.961429, -767.996865) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.207826,1017.77628 C559.916106,1001.74311 538.313285,911.273979 584.155586,840.605134 C633.254654,764.915324 715.11127,736.04894 743.006501,676.575792 C756.26671,648.301582 754.53137,584.902851 725.698767,570.334822 C698.755329,556.717606 711.111816,519.591372 677.796651,505.184591 C658.904999,497.013706 643.284535,496.91918 627.637632,496.621703 C574.01274,495.606946 523.050945,474.822482 455.019365,540.348034 C423.417909,570.787987 378.702859,641.670904 369.369998,722.323298 C365.317666,757.319931 374.648124,783.606328 369.716105,811.610863 C365.055683,838.089091 359.510767,864.609021 363.827485,889.402473 C377.758276,969.41265 435.671045,1027.71257 483.207826,1017.77628 Z",
    id: "Stroke-3",
    stroke: "url(#linearGradient-4)",
    transform: "translate(556.617143, 755.791536) rotate(-90.000000) translate(-556.617143, -755.791536) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.130196,1045.51443 C602.363543,1011.34633 573.829543,902.275711 619.72009,824.257138 C669.627047,739.410514 751.63176,712.237539 792.595796,659.960612 C816.957711,628.866798 815.410542,529.918519 767.491433,522.138104 C720.719528,514.544263 757.271979,454.202883 702.261282,436.951748 C674.575112,428.274663 653.410519,433.771635 632.130967,433.136727 C575.561127,431.440852 524.248306,408.929443 450.980544,473.386591 C404.187083,514.555402 352.311438,600.471346 347.341819,693.123448 C344.685766,742.704798 365.924604,773.091301 357.954052,807.309534 C350.048166,841.252082 339.220382,875.361712 346.927484,906.956769 C370.302659,1002.81962 465.599608,1067.4884 519.130196,1045.51443 Z",
    id: "Stroke-5",
    stroke: "url(#linearGradient-5)",
    transform: "translate(576.185714, 738.891850) rotate(-90.000000) translate(-576.185714, -738.891850) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.964282,1074.90893 C647.519597,1023.15697 611.684513,895.240438 658.057346,810.106488 C709.164703,716.270241 794.340423,692.608784 846.456305,645.964694 C883.316761,612.974975 880.885714,478.153357 813.336291,476.895864 C746.398241,475.649499 807.431975,391.51431 730.189654,371.8785 C693.466395,362.544675 666.561198,373.83151 639.456222,372.816056 C579.447861,370.573712 526.677282,345.312568 448.209809,409.489228 C385.464714,460.81275 327.100319,562.093801 325.672981,666.451815 C324.799248,730.52832 357.676156,764.889597 346.654605,805.25735 C335.373101,846.565441 319.133222,888.226854 330.383436,926.513623 C363.161658,1038.08275 497.020909,1109.16449 556.964282,1074.90893 Z",
    id: "Stroke-7",
    stroke: "url(#linearGradient-6)",
    transform: "translate(597.928571, 724.808777) rotate(-90.000000) translate(-597.928571, -724.808777) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.443564,1102.81027 C692.887412,1033.66152 649.797185,886.445924 696.37433,794.102857 C748.315224,691.121522 836.699334,672.344505 899.108191,629.8805 C948.780546,596.084096 945.038898,424.143288 858.156734,429.334385 C771.502866,434.511564 856.623548,326.219445 757.586436,304.347254 C712.025808,294.285155 679.552536,311.4617 646.781277,310.039368 C583.716371,307.300473 529.579031,278.742483 446.669213,343.187233 C368.068178,404.280733 304.193422,521.477044 305.976532,637.724205 C307.185298,716.364447 351.203128,754.756294 337.221814,801.339775 C322.598868,850.052579 301.016506,899.363821 315.798057,944.371881 C357.6651,1071.86688 529.555,1149.56632 595.443564,1102.81027 Z",
    id: "Stroke-9",
    stroke: "url(#linearGradient-7)",
    transform: "translate(618.584286, 708.847962) rotate(-90.000000) translate(-618.584286, -708.847962) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.742238,1130.33658 C736.174943,1044.17523 685.701654,878.020809 732.511268,778.795631 C785.25186,666.992419 876.793327,654.034072 949.534171,615.011906 C1012.12614,581.433466 1006.96772,372.103985 900.781155,383.69099 C794.503417,395.286322 903.59309,263.115632 782.838202,239.172672 C728.458914,228.38793 690.442597,251.442572 652.025604,249.588207 C585.913922,246.401364 530.308611,214.35805 443.071421,279.116469 C348.458898,349.351927 279.487295,482.410936 284.28582,610.214986 C287.774348,703.102566 342.679074,745.417063 325.761874,798.066591 C307.788997,854.005673 280.874069,910.824746 299.199637,962.374979 C350.056807,1105.41092 560.013882,1189.51247 631.742238,1130.33658 Z",
    id: "Stroke-11",
    stroke: "url(#linearGradient-8)",
    transform: "translate(637.065714, 692.887147) rotate(-90.000000) translate(-637.065714, -692.887147) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.395501,1159.67508 C783.917995,1056.20352 725.947765,870.316757 773.021624,763.786286 C826.542742,642.667629 921.040254,636.002001 1004.32993,599.717849 C1079.78755,566.848545 1073.26362,318.612999 947.787636,336.632719 C821.952274,354.705275 954.927299,198.03104 812.503002,171.960843 C749.316984,160.395409 705.772228,189.46055 661.721945,187.146907 C592.558257,183.512374 535.438557,147.664811 443.919099,213.183734 C333.144113,292.487186 259.358811,442.306697 267.059105,582.27654 C272.972088,689.774736 338.58032,736.220008 318.744994,795.170632 C297.412257,858.562227 265.168772,923.157917 287.059745,981.46061 C346.841245,1140.69042 594.901408,1231.57321 672.395501,1159.67508 Z",
    id: "Stroke-13",
    stroke: "url(#linearGradient-9)",
    transform: "translate(659.895714, 676.926332) rotate(-90.000000) translate(-659.895714, -676.926332) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.012923,1188.81835 C830.220084,1068.06789 764.381086,862.459957 811.952436,748.672602 C866.476596,618.261213 964.142785,618.236156 1058.62217,584.408988 C1147.22783,552.683837 1139.40262,265.152909 994.018477,289.608699 C848.033505,314.170285 1005.52318,132.96803 840.753844,104.817701 C768.452313,92.4645203 719.174604,127.569604 669.284048,124.774338 C596.746992,120.70951 537.834366,80.9437943 441.622187,147.300726 C314.013013,235.312614 235.29221,402.154332 245.862019,554.29028 C254.340938,676.35485 330.850685,726.942475 308.007112,792.185755 C283.207235,863.011214 245.477487,935.390217 271.044024,1000.41634 C340.012148,1175.83039 627.449427,1273.46144 711.012923,1188.81835 Z",
    id: "Stroke-15",
    stroke: "url(#linearGradient-10)",
    transform: "translate(680.551429, 660.965517) rotate(-90.000000) translate(-680.551429, -660.965517) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.486992,1216.80071 C874.910543,1079.03832 801.413669,854.120261 849.285996,733.325059 C904.545451,593.890991 1004.75406,600.705679 1110.23062,569.21626 C1211.51202,538.978518 1202.52411,212.47989 1037.84493,243.324 C872.337769,274.321093 1053.66318,68.9514474 867.257019,38.797151 C786.14982,25.6795731 731.348761,66.7763105 675.834909,63.4885715 C600.242856,59.0103483 539.806652,15.3156852 439.326845,82.452873 C295.299467,178.684604 212.154688,362.461425 225.510556,526.481216 C236.612846,662.830594 323.602387,717.473261 297.853042,788.874496 C269.68692,866.984722 226.626545,947.003059 255.769457,1018.61291 C333.612689,1209.86085 659.263073,1314.02822 748.486992,1216.80071 Z",
    id: "Stroke-17",
    stroke: "url(#linearGradient-11)",
    transform: "translate(700.120000, 645.004702) rotate(-90.000000) translate(-700.120000, -645.004702) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.042495,1247.58702 C920.731783,1092.58202 839.352255,847.886518 887.721165,719.965989 C943.509133,571.171212 1046.31644,585.061397 1162.95268,555.733344 C1276.81066,527.103975 1266.80512,161.252098 1082.79328,198.198876 C897.841768,236.025272 1102.91703,5.78780579 894.893321,-26.399009 C804.984872,-40.3114626 744.66876,6.86227699 683.53044,3.06265732 C604.883619,-1.82813517 542.918295,-49.5919988 438.154948,18.4977424 C277.615617,122.83836 190.185781,324.104075 206.289574,500.314569 C220.07536,651.152511 317.362118,709.911611 288.817318,787.649324 C257.165862,873.108755 208.89044,960.97322 241.620596,1039.276 C328.316916,1246.70184 692.188805,1357.56444 787.042495,1247.58702 Z",
    id: "Stroke-19",
    stroke: "url(#linearGradient-12)",
    transform: "translate(720.775714, 630.921630) rotate(-90.000000) translate(-720.775714, -630.921630) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.759967,1275.22017 C967.285292,1103.84176 877.788514,840.034449 926.506809,705.304428 C983.203294,547.805207 1088.383,568.642036 1216.53538,541.497242 C1343.0974,514.685615 1332.06082,110.162383 1128.45146,153.574063 C923.649916,197.588221 1152.95213,-56.5516862 922.899112,-90.3126247 C824.037675,-105.119128 758.077279,-51.7762903 691.212559,-56.1852023 C609.348554,-61.3520696 545.762904,-113.187326 436.51015,-44.3216751 C259.07817,67.5169866 167.30979,285.78312 186.16864,473.600552 C202.715109,638.379475 310.581395,701.142615 279.035639,784.867521 C244.009321,877.460227 190.172127,972.834878 226.632889,1057.50376 C322.100117,1280.52308 725.327359,1397.78681 825.759967,1275.22017 Z",
    id: "Stroke-21",
    stroke: "#F1F1F6",
    transform: "translate(741.431429, 615.899687) rotate(-90.000000) translate(-741.431429, -615.899687) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.59326,1076.01885 C315.289496,1315.44536 757.031721,1439.47011 863.429652,1304.18455 C1012.23795,1114.97397 915.176536,831.436358 964.235271,689.250175 C1021.83848,522.299667 1129.27567,550.227704 1269.05226,525.082175 C1408.26002,500.039599 1396.25935,54.8382429 1173.04691,104.923395 C948.384787,155.334101 1201.84852,-123.2423 949.834468,-159.41491 C841.986856,-174.894004 770.424467,-115.598749 697.82042,-120.459791 C612.762078,-126.155586 547.560044,-182.120179 433.805703,-112.112266 C239.394866,7.5355988 143.389514,244.048819 164.990718,444.389429 C184.342997,623.877921 302.743997,690.958636 268.196471,781.072955 C229.79433,881.24326 170.568629,984.485455 210.59326,1076.01885 Z",
    id: "Stroke-23",
    stroke: "url(#linearGradient-13)",
    transform: "translate(761.000000, 599.000000) rotate(-90.000000) translate(-761.000000, -599.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave1);
export default __webpack_public_path__ + "static/media/wave_1.b7d83fe1e8e37d429c7997e70621f29c.svg";
export { ForwardRef as ReactComponent };